import { CircularProgress } from '~/shadcn/ui/circular-progress'

type Props = {
  currentStep: number
  totalSteps: number
}

export const ProgressCircle = ({ currentStep, totalSteps }: Props) => {
  const progress = (currentStep / totalSteps) * 100

  return (
    <div className="relative inline-flex bg-[#121212]">
      <CircularProgress
        value={progress}
        size={240}
        strokeWidth={4}
        circleStrokeWidth={4}
        progressStrokeWidth={4}
        className="z-2 stroke-[#222]"
        progressClassName="stroke-[#99C8FF]"
      />

      <div className="absolute inset-0 flex items-center justify-center">
        <div
          className="flex flex-row items-flex-start text-primary-foreground font-semibold"
          translate="no">
          <span className="text-[80px] leading-[0.8]">{currentStep}</span>
          <span className="text-xl">/{totalSteps}</span>
        </div>
      </div>
    </div>
  )
}
